import {Input} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, DISABLE_AUTOCOMPLETE, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {useGeomagnetSuggest} from './EntranceInput.hooks'
import type {EntranceInputProps} from './EntranceInput.types'

export function EntranceInput({name, 'data-testid': dataTestId, names}: EntranceInputProps): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()
  const {setEntranceCoordinates} = useGeomagnetSuggest({...names})

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => (
        <div ref={field.ref}>
          <Input
            autoCapitalize="none"
            autoComplete={DISABLE_AUTOCOMPLETE}
            data-testid={dataTestId}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            label={t('cargo.create.address.porch', 'Подъезд')}
            name={name}
            onBlur={() => {
              field.onBlur()
              void setEntranceCoordinates(field.value?.toString())
            }}
            onChange={field.onChange}
            size="l"
            spellCheck="false"
            value={field.value?.toString()}
            variant="line"
          />
        </div>
      )}
    />
  )
}
